import { Flex, Text } from "@mantine/core";
import React from "react";
import Hint from "@/shared/ui/hint";

export const RetentionAddition = () => {
  return (
    <Flex gap="lg">
      <Flex gap={8} w={139} py="md" px={0} justify="flex-end">
        <Text>Keywords</Text>
        <Hint popupText="Enter keywords. Each individual keyword must be on a new line or separated by commas." />
      </Flex>
    </Flex>
  );
};
